import angular from 'angular';
import app from './app';

angular
    .bootstrap(document.getElementById('currency-exchange-app'), [app.name])
;
